import { render, staticRenderFns } from "./Messenger.vue?vue&type=template&id=3e8eda2a&"
import script from "./Messenger.vue?vue&type=script&lang=js&"
export * from "./Messenger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports